import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {authGuard} from './helpers/auth.guard';

const routes: Routes = [
    {
        path: 'home',
        loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
        canActivate: [authGuard],
        data: {
            breadcrumb: [
                { label: 'Home', url: 'home' }
            ]
        }
    },
    {
        path: 'stato-sili',
        loadComponent: () => import('./components/stato-sili/stato-sili.component').then(m => m.StatoSiliComponent),
        canActivate: [authGuard],
        data: {
            breadcrumb: [
                { label: 'Stato Sili', url: 'stato-sili' }
            ]
        }
    },
    {
        path: 'errori',
        loadComponent: () => import('./components/grid/grid.component').then(m => m.GridComponent),
        canActivate: [authGuard],
        data: {
            breadcrumb: [
                { label: 'Errori', url: 'errori' }
            ]
        }
    },
    {
        path: 'installation/:idInstallation',
        loadComponent: () => import('./components/installation/installation.component').then(m => m.InstallationComponent),
        canActivate: [authGuard],
        data: {
            breadcrumb: [
                { label: 'Home', url: 'home' },
                { key: 'installation', fallback: 'Impianto :idInstallation', url: 'installation/:idInstallation' }
            ]
        }
    },
    {
        path: 'installation/:idInstallation/sites/:idSito',
        loadComponent: () => import('./sites/sites.component').then(m => m.SitesComponent),
        canActivate: [authGuard],
        data: {
            breadcrumb: [
                { label: 'Home', url: 'home' },
                { key: 'installation', fallback: 'Impianto :idInstallation', url: 'installation/:idInstallation' },
                { key: 'site', fallback: 'Sito :idSito', url: 'installation/:idInstallation/sites/:idSito' }
            ]
        }
    },
    {
        path: 'installation/:idInstallation/sites/:idSito/sessions/:siloId',
        loadComponent: () => import('./sessions/sessions.component').then(m => m.SessionsComponent),
        canActivate: [authGuard],
        data: {
            breadcrumb: [
                { label: 'Home', url: 'home' },
                { key: 'installation', fallback: 'Impianto :idInstallation', url: 'installation/:idInstallation' },
                { key: 'site', fallback: 'Sito :idSito', url: 'installation/:idInstallation/sites/:idSito' },
                { key: 'silo', fallback: 'Silo :siloId', url: 'installation/:idInstallation/sites/:idSito/sessions/:siloId' }
            ]
        }
    },
    {path: 'login', loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent)},
    {path: '**', redirectTo: 'login'}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
